(function ($) {
  'use strict';

  let enviandoFormulario = false;

  $('#form-recuperacao').on('submit', function (e) {
    e.preventDefault();

    const obj = this;
    const form = $(obj);
    const submitBtn = $('#enviar-rec');
    const submitBtnText = submitBtn.text();
    const dados = new FormData(obj);

    function voltaSubmit() {
      submitBtn.attr('disabled', false);
      submitBtn.text(submitBtnText);
      enviandoFormulario = false;
    }

    if (!enviandoFormulario) {
      $.ajax({
        url: form.attr('action'),
        type: form.attr('method'),
        data: dados,
        contentType: false,
        processData: false,
        beforeSend: function () {
          enviandoFormulario = true;
          submitBtn.attr('disabled', true);
          submitBtn.text('Enviando...');
        },
        success: function (data) {
          console.log(data);
          voltaSubmit();
          const resp = JSON.parse(data);
          if (resp.status === 'success') {
            $('#modal-recuperacao').modal('hide');
            Alert.fire({
              type: 'success',
              title: 'Mensagem Enviada',
              text: 'Uma mensagem foi enviada para o seu e-mail com instruções para você cadastrar uma nova senha.',
              cancelButtonText: 'Fechar',
            });
          } else {
            Toast.fire({
              type: 'error',
              title: resp.message,
            });
          }
        },
        error: function (xhr, type, exception) {
          voltaSubmit();
          Toast.fire({
            type: 'error',
            title: 'Não foi possível realizar esta operação.',
          });
        },
      });
    }
  });
})(jQuery);
